export default __webpack_public_path__ + "static/media/chat.d8111c4b.jpeg";